module.exports = __webpack_public_path__ + "media/images/icon/icons8-Workflow-3bd4fb88eec67b34f7f380ae3feccace.png";